import { render, staticRenderFns } from "./ScrapReason.vue?vue&type=template&id=11d941de&scoped=true"
import script from "./ScrapReason.vue?vue&type=script&lang=ts"
export * from "./ScrapReason.vue?vue&type=script&lang=ts"
import style0 from "./ScrapReason.vue?vue&type=style&index=0&id=11d941de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d941de",
  null
  
)

export default component.exports